import Excerpt from './Excerpt'
export default Excerpt
